<template>
    <div class="cb-text-box-container">
        <RichTextBox
            v-model="localValue"
            :default-place-holder="defaultPlaceHolder"
            :is-sms-text-area="isSmsTextArea"
            :has-legacy-format="hasLegacyFormat"
            :funnel-id="funnelId"
            :has-error="hasError"
        >
            <template #footer>
                <MergeFieldMenuOption
                    :merge-field-categories="mergeFieldCategories"
                />
            </template>
        </RichTextBox>
    </div>
</template>

<script>

import MergeFieldMenuOption from '../mergeFieldMenuOption/MergeFieldMenuOption.vue';
import RichTextBox from '@/components/automatedSms/RichTextBox.vue';

export default {
    components: {
        RichTextBox,
        MergeFieldMenuOption,
    },

    props: {
        hasError: {
            type: Boolean,
            default: false,
        },

        mergeFieldCategories: {
            type: Array,
            default: () => [],
        },

        value: {
            type: String,
            default: '',
        },

        defaultPlaceHolder: {
            type: String,
            default: null,
        },

        hasLegacyFormat: {
            type: Boolean,
            default: false,
        },

        funnelId: {
            type: Number,
            default: 0,
        },
    },

    emits: ['input'],

    data() {
        return {
            localValue: this.value,
            isSmsTextArea: false,
        };
    },

    watch: {
        value(val) {
            if (this.localValue !== val) {
                this.localValue = val;
            }
        },

        localValue(val) {
            if (val !== this.value) {
                this.$emit('input', val);
            }
        },
    },
};
</script>
